import React from "react";
import { Route, Redirect } from "react-router-dom";

import { isLogin } from "app/_helpers/helper";

const PrivateRoute = ({ component: Component, isMobile = false, ...rest }) => {
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /auth/sign-in page
    <Route
      {...rest}
      render={(props) =>
        isLogin() ? (
          <Component {...props} />
        ) : (
          <Redirect to={`${isMobile ? "/mobile" : ""}/auth/sign-in`} />
        )
      }
    />
  );
};

export default PrivateRoute;
